export function formatBytes(bytes: number | string, decimals = 2): string {
  // 安全轉換為數字
  const numBytes = typeof bytes === 'string' ? parseInt(bytes) || 0 : bytes || 0;

  if (numBytes === 0 || isNaN(numBytes)) return '0 KB';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  const i = Math.floor(Math.log(numBytes) / Math.log(k));

  return parseFloat((numBytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function getUsageColor(percent: number): string {
  if (percent >= 90) return 'text-red-600 bg-red-50 dark:text-red-400 dark:bg-red-950';
  if (percent >= 75) return 'text-orange-600 bg-orange-50 dark:text-orange-400 dark:bg-orange-950';
  if (percent >= 60) return 'text-yellow-600 bg-yellow-50 dark:text-yellow-400 dark:bg-yellow-950';
  return 'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-950';
}

export function getProgressBarColor(percent: number): string {
  if (percent >= 90) return 'bg-red-500';
  if (percent >= 75) return 'bg-orange-500';
  if (percent >= 60) return 'bg-yellow-500';
  return 'bg-green-500';
}